<template>
	<core-button :color="color" :size="size" v-bind="$attrs" v-on="$listeners" @click="launchSetupWizard">
		<slot>Create a Free Account</slot>
	</core-button>
</template>
<script lang="js">
export default {
	inheritAttrs: false,
	props: {
		color: {
			type: String,
			default: 'blue',
		},
		size: {
			type: String,
			default: 'medium',
		},
	},
	methods: {
		launchSetupWizard() {
			this.$bus.$emit('launchSetupWizard');
		},
	},
};
</script>
